<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div v-if="getAuthenticated">
      <div v-if="loading">
        <v-progress-linear
          indeterminate
          color="primary darken-2"
        ></v-progress-linear>
      </div>
      <v-sheet :color="`grey darken-2`" class="pa-3" v-if="skeleton_loader">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>

      <div
        v-for="(bet, index) in betinprogressnew"
        :key="$uuid.v1()"
        :class="['single-bet', bet.result, 'cashout']"
        @click="openDetail(bet)"
        :title="$t('viewBetDetail')"
        v-if="betinprogressnew.length > 0 && bet.check_cashout"
      >
        <div class="info-bet">
          <div class="flex d-flex-center d-flex-center-all">
            <div class="type">
              {{ $t(bet.type) }}
              <span class="label-live-mybet" v-if="bet.bet_context == 'live'">{{
                $t('live')
              }}</span>
            </div>
            <div class="date">
              {{ new Date(bet.created_at).toLocaleString() }}
            </div>
          </div>
          <div class="flex d-flex-center d-flex">
            <div class="amount">
              {{ $t('amount') }}
              {{
                bet.currencySymbol +
                ' ' +
                parseFloat(bet.amount_real).toFixed(2)
              }}
            </div>
            <div class="result" v-if="bet.winning_real" :title="$t('winning')">
              {{
                bet.currencySymbol +
                ' ' +
                parseFloat(bet.winning_real).toFixed(2)
              }}
            </div>
            <div
              class="result"
              v-else
              :title="$t('potential') + ' ' + $t('winning')"
            >
              {{ getWinning(bet) }}
            </div>
            <div class="icon">
              <span
                v-if="bet.result == 'pending'"
                class="list-pending result-icon"
                :title="$t(bet.result).toUpperCase()"
              >
                <div class="circle-pending"></div>
              </span>
              <span
                v-if="bet.result == 'lose'"
                class="red--text result-icon"
                :title="$t(bet.result).toUpperCase()"
              >
                <v-icon small color="red">mdi-close-circle</v-icon>
              </span>
              <span
                v-if="bet.result == 'win'"
                class="green--text result-icon"
                :title="$t(bet.result).toUpperCase()"
              >
                <v-icon small color="green">mdi-checkbox-marked-circle</v-icon>
              </span>
              <span
                v-if="bet.result == 'void'"
                class="blue--text result-icon"
                :title="$t(bet.result).toUpperCase()"
              >
                <v-icon small color="blue">mdi-alert-circle</v-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="actions">
          <v-icon dense>mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>
    <div v-else class="message">
      {{ $t('loginMyBets') }}
    </div>
    <v-dialog
      v-model="dialog"
      width="75%"
      content-class="modal-on-top"
      :overlay-opacity="0.9"
      v-if="this.dialog && !getModalIdle"
    >
      <v-card v-if="checkIsMobile()" elevation="5" tile>
        <v-overlay :value="overlay_dialog_betlist_detail">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-toolbar flat dark color="black">
          <v-toolbar-title
            class="title-mybet text-center"
            style="text-transform: uppercase; font-size: 12px !important"
            >{{ $t('bet') }} {{ $t('code') }} :
            {{ betToShow.code }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-title>
          <span class="mybet-col-sx"
            >{{ $t(betToShow.type) }}
            <small>({{ getDetailMyBets.odds.length }})</small></span
          >
          <v-spacer></v-spacer>
          <span class="mybet-col-sx">{{
            new Date(betToShow.created_at).toLocaleString()
          }}</span>
        </v-card-title>

        <v-divider class="mx-4"></v-divider>

        <v-list>
          <v-list-item
            v-for="(odd, index) in getDetailMyBets.odds"
            :key="index"
            style="
              border-bottom: 1px solid rgb(57, 57, 57);
              margin: 0 15px;
              padding: 0px;
            "
          >
            <v-list-item-content>
              <div class="xs12">
                <small style="font-size: 12px; color: #a1a1a1">
                  {{
                    new Date(odd.time).toLocaleDateString('en-GB', {
                      month: 'numeric',
                      day: 'numeric',
                    })
                  }}
                  {{
                    new Date(odd.time).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  }}
                </small>
                <div
                  style="
                    margin-right: 0px;
                    max-height: 20px;
                    max-width: 20px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                  "
                >
                  <v-col xs="1" class="text-center">
                    <div
                      v-if="betToShow.cashout && !odd.result"
                      :title="$t('cashout')"
                    >
                      <v-icon small color="blue">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-if="betToShow.cashout && odd.result"
                      :title="$t('win')"
                    >
                      <v-icon small color="green"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </div>
                    <div
                      v-if="!betToShow.cashout && odd.result == undefined"
                      :title="$t('pending')"
                    >
                      <div
                        class="circle-pending"
                        style="margin: 4px auto"
                      ></div>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.void"
                      :title="$t('void')"
                    >
                      <v-icon small color="blue">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.cancelled"
                      :title="$t('cancelled')"
                    >
                      <v-icon small color="yellow">mdi-alert-circle</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.result"
                      :title="$t('win')"
                    >
                      <v-icon small color="green"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && !odd.result"
                      :title="$t('lose')"
                    >
                      <v-icon small color="red">mdi-close-circle</v-icon>
                    </div>
                    <div
                      v-if="!betToShow.cashout && odd.half_won"
                      :title="$t('halfWon')"
                    >
                      <v-icon small color="green">mdi-star-half</v-icon>
                    </div>
                    <div
                      v-else-if="!betToShow.cashout && odd.half_lost"
                      :title="$t('halfLost')"
                    >
                      <v-icon small color="red">mdi-star-half</v-icon>
                    </div>
                  </v-col>
                </div>
              </div>
              <div class="xs12">
                <small style="font-size: 12px; color: #a1a1a1">
                  {{ odd.category.name
                  }}<v-icon x-small style="color: #a1a1a1"
                    >mdi-chevron-right</v-icon
                  >{{ odd.tournament.name }}
                </small>
              </div>
              <div
                class="xs12"
                style="padding-top: 5px; padding-bottom: 5px; font-size: 16px"
              >
                <small>
                  {{
                    odd.event_description != null
                      ? odd.event_description
                      : odd.tournament.name
                  }}
                </small>
              </div>
              <small style="font-size: 11px; color: #a1a1a1">
                <span>{{ odd.outcome_alias || odd.outcome_name }}</span
                ><span>
                  ( {{ odd.market_name }}
                  {{ getSpecifiers(odd.market_unique_id) }})
                </span>
              </small>
            </v-list-item-content>
            <v-list-item-action>
              <small style="font-size: 11px; text-align: right">
                <br />
                <span
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    !odd.match_result
                  "
                  class="yellow--text"
                  >&nbsp;{{ odd.result_actual_home }} -
                  {{ odd.result_actual_away }}</span
                >
                &nbsp;<v-icon
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    odd.time_actual >= 0 &&
                    !odd.match_result
                  "
                  x-small
                  >mdi-timer</v-icon
                >&nbsp;<span
                  v-if="
                    betToShow.status != 'finished' &&
                    !odd.match_result &&
                    odd.time_actual != '' &&
                    odd.time_actual >= 0
                  "
                  >{{ parseFloat(odd.time_actual).toFixed(2) }}</span
                >
                <span
                  v-if="
                    betToShow.status != 'finished' &&
                    odd.show_time &&
                    odd.time_actual >= 0 &&
                    !odd.match_result
                  "
                  class="blink_me"
                  >'</span
                >
                <br />
                <span v-if="odd.match_result"> [{{ odd.match_result }}] </span>
                <span v-else>
                  {{ odd.outcome_odd_value | odds_type_filter }}
                </span>
              </small>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('amount') }}
          </v-list-item-content>
          <v-list-item-action>
            {{
              betToShow.currencySymbol +
              ' ' +
              parseFloat(betToShow.amount_real).toFixed(2)
            }}
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('potential') }} {{ $t('winning') }}
          </v-list-item-content>
          <v-list-item-action>
            {{ getWinning(betToShow) }}
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('bets.status') }}
          </v-list-item-content>
          <v-list-item-action>
            <div
              class="icon"
              :style="betToShow.result == 'pending' ? 'display: flex' : ''"
            >
              <span
                v-if="betToShow.result == 'pending'"
                class="list-pending result-icon"
                :title="$t(betToShow.result)"
                style="display: flex"
              >
                <div class="circle-pending" style="margin: 5px 5px"></div>
              </span>
              <span
                v-if="betToShow.result == 'lose'"
                class="red--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="red">mdi-close-circle</v-icon>
              </span>
              <span
                v-if="betToShow.result == 'win'"
                class="green--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="green">mdi-checkbox-marked-circle</v-icon>
                <small class="light-green--text" v-if="betToShow.cashout"
                  >(cashout)</small
                >
              </span>
              <span
                v-if="betToShow.result == 'void'"
                class="blue--text result-icon"
                :title="$t(betToShow.result)"
              >
                <v-icon small color="blue">mdi-alert-circle</v-icon>
              </span>
            </div>
          </v-list-item-action>
        </v-list-item>

        <v-list-item dense style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('betCreationDate') | capitalize }}
          </v-list-item-content>
          <v-list-item-action>
            {{ new Date(betToShow.created_at).toLocaleString() }}
          </v-list-item-action>
        </v-list-item>

        <v-divider class="mx-4"></v-divider>

        <v-list-item style="font-size: 12px; color: #a1a1a1">
          <v-list-item-content>
            {{ $t('winning') }}
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              style="font-size: 12px"
              v-if="(cashout > 0 || cashout_prematch > 0) && !betToShow.cashout"
              class="btn-cashout"
              rounded
              color="#a0c528"
              dark
              @click="
                getDialogCashout(
                  cashout > 0
                    ? parseFloat(cashout).toFixed(2)
                    : cashout_prematch > 0
                    ? parseFloat(cashout_prematch).toFixed(2)
                    : '',
                  getWinning(betToShow),
                  betToShow.currencySymbol
                )
              "
            >
              Cashout: {{ betToShow.currencySymbol }}
              {{
                cashout > 0
                  ? parseFloat(cashout).toFixed(2)
                  : cashout_prematch > 0
                  ? parseFloat(cashout_prematch).toFixed(2)
                  : ''
              }}
            </v-btn>

            <span v-else>
              {{
                betToShow.winning_real
                  ? betToShow.currencySymbol +
                    ' ' +
                    parseFloat(betToShow.winning_real).toFixed(2)
                  : betToShow.currencySymbol + ' 0.00'
              }}
            </span>
          </v-list-item-action>
        </v-list-item>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions style="padding-bottom: 20px; padding-top: 20px">
          <v-row align="center" justify="space-around">
            <v-btn color="black" dark block @click="dialog = false">
              {{ $t('close') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>

      <v-card v-if="!checkIsMobile()">
        <v-overlay :value="overlay_dialog_betlist_detail">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card-title class="text-h6 lighten-2 text-uppercase">
          <span class="title-mybet">
            {{ $t('bet') }} {{ $t('code') }} : {{ betToShow.code }}</span
          >
        </v-card-title>

        <v-card-text>
          <v-container class="bg-bet-detail mt-4 mb-6">
            <v-row>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('type') }}</td>
                        <td class="mybet-col-dx">{{ $t(betToShow.type) }}</td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('bets.code') | capitalize }}
                        </td>
                        <td class="mybet-col-dx">
                          <span> {{ betToShow.code }}</span>
                          <v-icon
                            class="ml-2"
                            v-if="
                              betToShow.result !== 'cancelled' &&
                              betToShow.status !== 'review'
                            "
                            @click="printBet(betToShow.code)"
                            :title="$t('print')"
                            >mdi-printer</v-icon
                          >
                          <v-icon
                            class="ml-2"
                            @click="rebet(betToShow.odds)"
                            :title="$t('rebet')"
                            v-if="betToShow.result == 'pending'"
                            >mdi-backup-restore</v-icon
                          >
                        </td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('betCreationDate') | capitalize }}
                        </td>
                        <td class="mybet-col-dx">
                          {{ new Date(betToShow.created_at).toLocaleString() }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('amount') }}</td>
                        <td class="mybet-col-dx">
                          {{
                            betToShow.currencySymbol +
                            ' ' +
                            parseFloat(betToShow.amount_real).toFixed(2)
                          }}
                        </td>
                        <td></td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">
                          {{ $t('potential') }} {{ $t('winning') }}
                        </td>
                        <td class="mybet-col-dx">
                          {{ getWinning(betToShow) }}
                        </td>
                        <td>
                          <v-btn
                            v-if="
                              (cashout > 0 || cashout_prematch > 0) &&
                              !betToShow.cashout
                            "
                            class="btn-cashout"
                            rounded
                            color="#a0c528"
                            dark
                            @click="
                              getDialogCashout(
                                cashout > 0
                                  ? parseFloat(cashout).toFixed(2)
                                  : cashout_prematch > 0
                                  ? parseFloat(cashout_prematch).toFixed(2)
                                  : '',
                                getWinning(betToShow),
                                betToShow.currencySymbol
                              )
                            "
                          >
                            Cashout: {{ betToShow.currencySymbol }}
                            {{
                              cashout > 0
                                ? parseFloat(cashout).toFixed(2)
                                : cashout_prematch > 0
                                ? parseFloat(cashout_prematch).toFixed(2)
                                : ''
                            }}
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td class="mybet-col-sx">{{ $t('winning') }}</td>
                        <td class="mybet-col-dx">
                          <div
                            class="icon"
                            :style="
                              betToShow.result == 'pending'
                                ? 'display: flex'
                                : ''
                            "
                          >
                            {{
                              betToShow.winning_real
                                ? betToShow.currencySymbol +
                                  ' ' +
                                  parseFloat(betToShow.winning_real).toFixed(2)
                                : betToShow.currencySymbol + ' 0.00'
                            }}
                            <span
                              v-if="betToShow.result == 'pending'"
                              class="list-pending result-icon"
                              :title="$t(betToShow.result)"
                              style="display: flex"
                            >
                              <div
                                class="circle-pending"
                                style="margin: 5px 5px"
                              ></div>
                            </span>
                            <span
                              v-if="betToShow.result == 'lose'"
                              class="red--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="red"
                                >mdi-close-circle</v-icon
                              >
                            </span>
                            <span
                              v-if="betToShow.result == 'win'"
                              class="green--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="green"
                                >mdi-checkbox-marked-circle</v-icon
                              >
                              <small
                                class="light-green--text"
                                v-if="betToShow.cashout"
                                >(cashout)</small
                              >
                            </span>
                            <span
                              v-if="betToShow.result == 'void'"
                              class="blue--text result-icon"
                              :title="$t(betToShow.result)"
                            >
                              <v-icon small color="blue"
                                >mdi-alert-circle</v-icon
                              >
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-container
                  fluid
                  class="no-padding no-margin"
                  style="padding: 0 35px 0 10px !important; font-size: 12px"
                >
                  <v-row>
                    <v-col cols="12" md="3">
                      {{ $t('event') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="3">
                      {{ $t('tournament') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="2">{{
                      $t('sign') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1">
                      {{ $t('odd') | capitalize }}</v-col
                    >
                    <v-col cols="12" md="1">{{
                      $t('date') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1" class="text-center">{{
                      $t('score') | capitalize
                    }}</v-col>
                    <v-col cols="12" md="1" class="text-center">
                      {{ $t('result') | capitalize }}</v-col
                    >
                  </v-row>
                </v-container>
                <v-expansion-panels tile multiple class="tree">
                  <v-expansion-panel
                    v-for="(odd, index) in getDetailMyBets.odds"
                    :key="index"
                  >
                    <template>
                      <v-expansion-panel-header class="tree-sport-level">
                        <v-container
                          fluid
                          class="no-padding no-margin"
                          style="font-size: 12px"
                        >
                          <v-row>
                            <v-col cols="12" md="3">{{
                              odd.event_description != null
                                ? odd.event_description
                                : odd.tournament.name
                            }}</v-col>
                            <v-col cols="12" md="3">
                              {{ odd.sport.name
                              }}<v-icon x-small>mdi-chevron-right</v-icon
                              >{{ odd.category.name
                              }}<v-icon x-small>mdi-chevron-right</v-icon
                              >{{ odd.tournament.name }}
                              <span
                                v-if="
                                  betToShow.status != 'finished' &&
                                  odd.show_time &&
                                  !odd.match_result
                                "
                                class="yellow--text"
                                >&nbsp;{{ odd.result_actual_home }} -
                                {{ odd.result_actual_away }}</span
                              >
                              &nbsp;<v-icon
                                v-if="
                                  betToShow.status != 'finished' &&
                                  odd.show_time &&
                                  odd.time_actual >= 0 &&
                                  !odd.match_result
                                "
                                x-small
                                >mdi-timer</v-icon
                              >&nbsp;<span
                                v-if="
                                  betToShow.status != 'finished' &&
                                  !odd.match_result &&
                                  odd.time_actual != '' &&
                                  odd.time_actual >= 0
                                "
                                >{{
                                  parseFloat(odd.time_actual).toFixed(2)
                                }}</span
                              >
                              <span
                                v-if="
                                  betToShow.status != 'finished' &&
                                  odd.show_time &&
                                  odd.time_actual >= 0 &&
                                  !odd.match_result
                                "
                                class="blink_me"
                                >'</span
                              >
                            </v-col>
                            <v-col cols="12" md="2">
                              <span>{{
                                odd.outcome_alias || odd.outcome_name
                              }}</span
                              ><span>
                                ( {{ odd.market_name }}
                                {{ getSpecifiers(odd.market_unique_id) }})
                              </span>
                            </v-col>
                            <v-col cols="12" md="1">
                              <span
                                >{{ odd.outcome_odd_value | odds_type_filter }}
                              </span>
                            </v-col>
                            <v-col cols="12" md="1">
                              {{
                                new Date(odd.time).toLocaleDateString('en-GB', {
                                  month: 'numeric',
                                  day: 'numeric',
                                })
                              }}
                              {{
                                new Date(odd.time).toLocaleTimeString([], {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                })
                              }}
                            </v-col>
                            <v-col cols="12" md="1" class="text-center">
                              <template v-if="odd.match_result">
                                [{{ odd.match_result }}]
                              </template>
                            </v-col>
                            <v-col cols="12" md="1" class="text-center">
                              <div
                                v-if="betToShow.cashout && !odd.result"
                                :title="$t('cashout')"
                              >
                                <v-icon small color="blue"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-if="betToShow.cashout && odd.result"
                                :title="$t('win')"
                              >
                                <v-icon small color="green"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </div>
                              <div
                                v-if="
                                  !betToShow.cashout && odd.result == undefined
                                "
                                :title="$t('pending')"
                              >
                                <div
                                  class="circle-pending"
                                  style="margin: 4px auto"
                                ></div>
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.void"
                                :title="$t('void')"
                              >
                                <v-icon small color="blue"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.cancelled"
                                :title="$t('cancelled')"
                              >
                                <v-icon small color="yellow"
                                  >mdi-alert-circle</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.result"
                                :title="$t('win')"
                              >
                                <v-icon small color="green"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && !odd.result"
                                :title="$t('lose')"
                              >
                                <v-icon small color="red"
                                  >mdi-close-circle</v-icon
                                >
                              </div>
                              <div
                                v-if="!betToShow.cashout && odd.half_won"
                                :title="$t('halfWon')"
                              >
                                <v-icon small color="green"
                                  >mdi-star-half</v-icon
                                >
                              </div>
                              <div
                                v-else-if="!betToShow.cashout && odd.half_lost"
                                :title="$t('halfLost')"
                              >
                                <v-icon small color="red">mdi-star-half</v-icon>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="no-padding">
                        <v-expansion-panels tile class="tree-inner">
                          <v-expansion-panel>
                            <v-card-text v-if="odd.match_livescore">
                              <v-container class="mt04 mb-0 no-padding">
                                <v-row style="color: #ffffff">
                                  <v-col
                                    cols="12"
                                    md="6"
                                    class="no-padding no-margin pt-0 pb-0 pr-0 pl-0"
                                  >
                                    <div>
                                      {{ $t('statistics.matchsummary') }}
                                    </div>
                                    <div
                                      v-if="
                                        odd.match_livescore.Periods.length > 0
                                      "
                                      v-for="(period, index) in sortby(
                                        odd.match_livescore.Periods
                                      )"
                                      :key="index"
                                      style="border-bottom: 1px solid #000000"
                                    >
                                      <v-row
                                        class="no-padding no-margin align-self-center"
                                        style="
                                          background-color: #272727;
                                          font-size: 12px;
                                        "
                                      >
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2"
                                        >
                                          {{ period.Type[0].text }}
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2 text-right"
                                        >
                                          {{ period.Results[0].Value }} :
                                          {{ period.Results[1].Value }}
                                        </v-col>
                                      </v-row>
                                      <v-row
                                        :class="
                                          index % 2 == 0
                                            ? 'evenResult d-flex no-padding no-margin '
                                            : 'oddResult dd-flex no-padding no-margin '
                                        "
                                        v-for="(
                                          player, index
                                        ) in period.Incidents"
                                        :key="index"
                                        style="font-size: 12px"
                                      >
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2"
                                        >
                                          <span
                                            v-if="
                                              player.ParticipantPosition == '1'
                                            "
                                          >
                                            <span
                                              v-if="
                                                player.PlayerName != 'Unknown'
                                              "
                                              >{{ player.PlayerName }}</span
                                            >
                                            <span v-if="player.Seconds">
                                              ({{
                                                (player.Seconds / 60).toFixed(
                                                  0
                                                )
                                              }}°)
                                            </span>
                                          </span>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2 text-right"
                                        >
                                          <span
                                            v-if="
                                              player.ParticipantPosition == '2'
                                            "
                                          >
                                            <span v-if="player.Seconds">
                                              ({{
                                                (player.Seconds / 60).toFixed(
                                                  0
                                                )
                                              }}°)
                                            </span>
                                            <span
                                              v-if="
                                                player.PlayerName != 'Unknown'
                                              "
                                              >{{ player.PlayerName }}</span
                                            >
                                          </span>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    md="6"
                                    class="no-padding no-margin pt-2 pb-2 pr-2 pl-2"
                                  >
                                    <div>{{ $t('statistics.statistics') }}</div>
                                    <v-row
                                      class="no-padding no-margin align-self-center"
                                      style="
                                        background-color: #272727;
                                        font-size: 12px;
                                      "
                                    >
                                      <v-col
                                        cols="12"
                                        sm="12"
                                        class="pt-1 pb-1 pr-2 pl-2 text-center"
                                      >
                                        {{
                                          odd.event_description != null
                                            ? odd.event_description
                                            : odd.tournament.name
                                        }}
                                      </v-col>
                                    </v-row>
                                    <div
                                      v-for="(stat, index) in odd
                                        .match_livescore.Statistics"
                                      :key="index"
                                    >
                                      <v-row
                                        :class="
                                          index % 2 == 0
                                            ? 'evenResult d-flex no-padding no-margin '
                                            : 'oddResult dd-flex no-padding no-margin '
                                        "
                                        style="font-size: 12px"
                                      >
                                        <v-col
                                          cols="12"
                                          sm="2"
                                          class="pt-1 pb-1 pr-2 pl-2"
                                        >
                                          {{ stat.Results[0].Value }}
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          sm="8"
                                          class="pt-1 pb-1 pr-2 pl-2 text-center"
                                        >
                                          {{ result(stat.Type) }}
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          sm="2"
                                          class="pt-1 pb-1 pr-2 pl-2 text-right"
                                        >
                                          {{ stat.Results[1].Value }}
                                        </v-col>
                                      </v-row>
                                      <v-row
                                        v-if="stat.Incidents"
                                        v-for="inc in stat.Incidents"
                                        :class="
                                          index % 2 == 0
                                            ? 'evenResult d-flex no-padding no-margin '
                                            : 'oddResult dd-flex no-padding no-margin '
                                        "
                                        style="font-size: 12px"
                                      >
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2"
                                        >
                                          <span
                                            v-if="
                                              inc.ParticipantPosition == '1'
                                            "
                                          >
                                            <span
                                              v-if="inc.PlayerName != 'Unknown'"
                                              >{{ inc.PlayerName }}</span
                                            >
                                            <span v-if="inc.Seconds">
                                              ({{
                                                (inc.Seconds / 60).toFixed(0)
                                              }}°)
                                            </span>
                                          </span>
                                        </v-col>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                          class="pt-1 pb-1 pr-2 pl-2 text-right"
                                        >
                                          <span
                                            v-if="
                                              inc.ParticipantPosition == '2'
                                            "
                                          >
                                            <span v-if="inc.Seconds">
                                              ({{
                                                (inc.Seconds / 60).toFixed(0)
                                              }}°)
                                            </span>
                                            <span
                                              v-if="inc.PlayerName != 'Unknown'"
                                              >{{ inc.PlayerName }}</span
                                            >
                                          </span>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-text v-else>
                              <div class="text-center" v-if="">
                                {{ $t('noinfo') }}
                              </div>
                            </v-card-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-expansion-panel-content>
                    </template>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="dialog = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      content-class="modal-on-top"
      v-model="dialog_cashout"
      persistent
      width="30%"
      :overlay-opacity="0.9"
      v-if="!getModalIdle"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t('titleModalCashout') }}
        </v-card-title>
        <v-card-text>
          {{ $t('textPropostCashout1') }}
          <span class="red--text"> {{ potential_win }}</span>
          {{ $t('textPropostCashout2') }}
          <span class="light-green--text"> {{ cashout_value }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog_cashout = false">
            {{ $t('Disagree') }}
          </v-btn>
          <v-btn color="light-green darken-1" text @click="defineCashout()">
            {{ $t('Agree') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!getModalIdle"
      content-class="modal-on-top"
      v-model="dialog_cashout_accept"
      persistent
      width="30%"
      :overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title class="text-h5 green--text">
          {{ $t('titleModalCashoutAccept') }}
        </v-card-title>
        <v-card-text>
          {{ $t('textAcceptCashout') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="light-green darken-1"
            text
            @click="dialog_cashout_accept = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!getModalIdle"
      content-class="modal-on-top"
      v-model="dialog_cashout_reject"
      persistent
      width="30%"
      :overlay-opacity="0.9"
    >
      <v-card>
        <v-card-title class="text-h5 red--text">
          {{ $t('titleModalCashoutReject') }}
        </v-card-title>
        <v-card-text>
          {{ $t('textRejectCashout') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialog_cashout_reject = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!getModalIdle"
      content-class="modal-on-top modal-mybetlist"
      v-model="dialog_betlist"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-overlay :value="overlay_dialog_betlist">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="#000000">
          <v-btn icon dark @click="dialog_betlist = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ $t('myBets') }} {{ $t('Cashout') }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-chip
              v-if="betinprogressnewall.length > 0"
              class="ma-2"
              color="#1e1e1e"
              text-color="black"
            >
              <v-avatar left class="yellow text-count-mybets">
                {{ betinprogressnewall.length }}
              </v-avatar>
              <span class="white--text"
                >{{ $t('myBets') }} {{ $t('Cashout') }}</span
              >
            </v-chip>
          </v-toolbar-items>
        </v-toolbar>

        <template>
          <v-card elevation="24">
            <v-data-table
              :headers="betsHeaders"
              :items="betinprogressnewall"
              :items-per-page="30"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, -1],
              }"
              class="elevation-1 datatable-mybets"
              @click:row="handleClick"
            >
              <template v-slot:item.created_at="{ item }" class="fs12">
                <span>{{ new Date(item.created_at).toLocaleString() }}</span>
              </template>

              <template v-slot:item.amount_real="{ item }" class="fs12">
                <span>{{ item.code }}</span>
              </template>

              <template v-slot:item.bet_context="{ item }" class="fs12">
                <span>{{ item.bet_context }}</span>
              </template>

              <template v-slot:item.amount_real="{ item }" class="fs12">
                <span>{{
                  item.currencySymbol +
                  ' ' +
                  parseFloat(item.amount_real).toFixed(2)
                }}</span>
              </template>

              <template v-slot:item.winning_real="{ item }" class="fs12">
                <span v-if="item.winning_real">{{
                  item.currencySymbol +
                  ' ' +
                  parseFloat(item.winning_real).toFixed(2)
                }}</span>
                <span v-else="item.winning_real">{{ getWinning(item) }}</span>
              </template>

              <template v-slot:item.payed="{ item }" class="fs12">
                <span>{{
                  item.payed == 'false' ? $t('generic.yes') : $t('generic.yes')
                }}</span>
              </template>

              <template v-slot:item.result="{ item }" class="fs12">
                <div class="icon">
                  <span
                    v-if="item.result == 'pending'"
                    class="list-pending result-icon"
                    :title="$t(item.result)"
                  >
                    <div class="circle-pending"></div>
                  </span>
                  <span
                    v-if="item.result == 'lose'"
                    class="red--text result-icon"
                    :title="$t(item.result)"
                  >
                    <v-icon small color="red">mdi-close-circle</v-icon>
                  </span>
                  <span
                    v-if="item.result == 'win'"
                    class="green--text result-icon"
                    :title="$t(item.result)"
                  >
                    <v-icon small color="green"
                      >mdi-checkbox-marked-circle</v-icon
                    >
                  </span>
                  <span
                    v-if="item.result == 'void'"
                    class="blue--text result-icon"
                    :title="$t(item.result)"
                  >
                    <v-icon small color="blue">mdi-alert-circle</v-icon>
                  </span>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </template>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import orderByLodash from 'lodash/orderBy'
import { isMobileOnly } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'
import moment from 'moment-timezone'
// import _ from 'lodash'

export default {
  name: 'MyBets',
  data() {
    return {
      dialog: false,
      dialog_cashout: false,
      dialog_cashout_accept: false,
      dialog_cashout_reject: false,
      dialog_betlist: false,
      overlay_dialog_betlist: false,
      overlay_dialog_betlist_detail: false,
      betToShow: {},
      betToShowAll: {},
      loading: false,
      rules_manager: [],
      rules_skin: [],
      cashout: 0,
      overlay: false,
      isMobileOnly: isMobileOnly,
      cashout_value: 0,
      cashout_prematch: 0,
      potential_win: 0,
      applicabile: [],
      betsHeaders: [
        {
          text: _.upperCase(this.$t('bets.date')),
          align: 'start',
          sortable: false,
          value: 'created_at',
        },
        {
          text: _.upperCase(this.$t('bets.code')),
          sortable: false,
          value: 'code',
        },
        {
          text: _.upperCase(this.$t('bets.context')),
          sortable: false,
          value: 'bet_context',
        },
        {
          text: _.upperCase(this.$t('bets.type')),
          sortable: false,
          value: 'type',
        },
        {
          text: _.upperCase(this.$t('bets.amount')),
          sortable: false,
          value: 'amount_real',
        },
        {
          text: _.upperCase(this.$t('bets.winning')),
          sortable: false,
          value: 'winning_real',
        },
        {
          text: _.upperCase(this.$t('bets.payed')),
          sortable: false,
          value: 'payed',
        },
        {
          text: _.upperCase(this.$t('bets.result')),
          sortable: false,
          value: 'result',
        },
      ],
      enableTimezone: true,
      dialogFromTime: false,
      dialogToTime: false,
      filterType: '',
      filterResult: '',
      filterPayed: '',
      filterCode: '',
      filterContext: '',
      filterFromTime: '',
      filterToTime: '',
      filterPlatform: '',
      check_cashout_bet: '',
      betinprogressnew: [],
      betinprogressnewall: [],
      skeleton_loader: false,
      visible_list_cashout: [],
      show_list_cashout: false,
      typeOfBets: [
        { text: this.$t('generic.selectOption'), value: '' },
        { text: this.$t('bets.single'), value: 'single' },
        { text: this.$t('bets.multiple'), value: 'multiple' },
        { text: this.$t('bets.integral'), value: 'integral' },
        { text: this.$t('bets.system'), value: 'system' },
      ],
      typeOfResults: [
        { text: this.$t('generic.selectOption'), value: '' },
        { text: this.$t('bets.pending'), value: 'pending' },
        { text: this.$t('bets.win'), value: 'win' },
        { text: this.$t('bets.lose'), value: 'lose' },
        { text: this.$t('bets.void'), value: 'void' },
        { text: this.$t('bets.cancelled'), value: 'cancelled' },
      ],
      typeOfContexts: [
        { text: this.$t('generic.selectOption'), value: '' },
        { text: this.$t('bets.prematch'), value: 'prematch' },
        { text: this.$t('bets.live'), value: 'live' },
        { text: this.$t('bets.mixed'), value: 'mixed' },
        { text: this.$t('bets.antepost'), value: 'antepost' },
      ],
      typeOfStatus: [
        { text: this.$t('generic.selectOption'), value: '' },
        { text: this.$t('bets.accepted'), value: 'accepted' },
        { text: this.$t('bets.review'), value: 'review' },
        { text: this.$t('bets.finished'), value: 'finished' },
      ],
      typeOfPayed: [
        { text: this.$t('generic.selectOption'), value: '' },
        { text: this.$t('generic.yes'), value: 'yes' },
        { text: this.$t('generic.no'), value: 'no' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getAuthenticated: 'user/getAuthenticated',
      getMyBetsInProgress: 'user/getMyBetsInProgress',
      getPlatformSettings: 'settings/getPlatformSettings',
      getDetailMyBets: 'user/getDetailMyBets',
      getCashout: 'settings/getCashout',
      getCashoutLive: 'settings/getCashoutLive',
      getModalIdle: 'user/getModalIdle',
      getOddsType: 'odds/getOddsType',
    }),
  },
  watch: {
    getDetailMyBets: async function (val) {
      if (this.dialog) {
        await this.checkCashout2(val)
        await this.checkCashoutPrematch(val)
      }
    },
    getMyBetsInProgress: async function (val) {
      this.loading = true
      const arraybetinprogressnew = []
      await this.checkCashoutList(val)
      this.loading = false
    },
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false
        }, 3000)
    },
  },
  methods: {
    ...mapActions({
      fetchMyBetsInProgress: 'user/fetchMyBetsInProgress',
      fetchMyBetsInProgressAll: 'user/fetchMyBetsInProgressAll',
      fetchMyBetsInProgressAllFilter: 'user/fetchMyBetsInProgressAllFilter',
      resetCart: 'cart/resetCart',
      setOddsInCart: 'cart/setOddsInCart',
      refreshCart: 'cart/refreshCart',
      fetchEventResultAndTimeDetail: 'odds/fetchEventResultAndTimeDetail',
      setCreatedAtCart: 'cart/setCreatedAtCart',
      fetchCashout: 'odds/fetchCashout',
      setDetailMyBet: 'user/setDetailMyBet',
      sentCashout: 'odds/sentCashout',
    }),
    checkIsMobile() {
      return checkIsMobileDevice()
    },
    checkIsTablet() {
      return checkIsTabletDevice()
    },

    getDialogCashout(cashout_value, potential_win, simbol) {
      this.dialog_cashout = true
      this.cashout_value = simbol + ' ' + cashout_value
      this.potential_win = simbol + ' ' + potential_win
    },

    printBet(code) {
      window.open(
        this.getPlatformSettings.print_endpoint +
          code +
          '&type_odd=' +
          this.getOddsType,
        '_blank',
        'height=600,width=350'
      )
    },
    async openDetail(bet) {
      this.overlay_dialog_betlist = true
      this.overlay = true
      const sleep = m => new Promise(r => setTimeout(r, m))
      await sleep(100)
      document.body.scrollIntoView({ behavior: 'smooth', block: 'start' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )

      this.betToShow = bet
      await this.checkCashout2(this.betToShow)
      await this.checkCashoutPrematch(this.betToShow)

      if (this.betToShow.result == 'pending') {
        for (let i = 0; i < this.betToShow.odds.length; i++) {
          const data = await this.getLiveDate(
            this.betToShow.odds[i].event_source
          )

          if (data.livescore) {
            const time_actual = data.livescore.Scoreboard.Time
            const result_actual = data.livescore.Scoreboard.Results

            this.betToShow.odds[i].show_time = true
            Object.assign(this.betToShow.odds[i], {
              time_actual: time_actual / 60,
            })
            this.betToShow.odds[i].result_actual_home = await this.getResult(
              result_actual,
              'home'
            )
            this.betToShow.odds[i].result_actual_away = await this.getResult(
              result_actual,
              'away'
            )
          } else {
            this.betToShow.odds[i].show_time = false
            this.betToShow.odds[i].time_actual = ''
            this.betToShow.odds[i].result_actual_home = ''
            this.betToShow.odds[i].result_actual_away = ''
          }
        }
      }

      this.setDetailMyBet(this.betToShow)
      this.dialog = true
      this.overlay = false
      this.overlay_dialog_betlist = false
    },
    getWinning(bet) {
      switch (bet.type) {
        case 'single':
        case 'multiple':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._multiple_detail.winning_total).toFixed(2)
          )
        case 'integral':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._integral_detail.winning_total_max).toFixed(2)
          )
        case 'system':
          return (
            bet.currencySymbol +
            ' ' +
            parseFloat(bet._system_detail.winning_all_total).toFixed(2)
          )
      }
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Here's a title!",
        text: 'Prova Msg',
        icon: 'success',
        closeOnClickOutside: false,
        closeOnEsc: false,
      })
    },
    async checkCashout(bet) {
      this.loading = true
      const amount_real = bet.amount_real
      const winning = bet._multiple_detail.winning_total
      const applicabile = []
      const moltiplicatore_orig = []
      const moltiplicatore = []
      const defined = []

      for (let i = 0; i < bet.odds.length; i++) {
        moltiplicatore_orig.push(bet.odds[i].outcome_odd_value_for_order)
        defined.push(bet.odds[i].defined)
      }

      const check_def = defined.includes(true)

      for (let i = 0; i < bet.odds.length; i++) {
        const id_event = bet.odds[i].event_source
        const id_outcome = bet.odds[i].id_outcome
        const odd_value = bet.odds[i].outcome_odd_value_for_order
        const odds_instant = await this.fetchCashout(id_event)

        for (let n = 0; n < odds_instant.length; n++) {
          if (
            odds_instant[n].sport_event_status._attributes.status == 2 &&
            check_def == false
          ) {
            applicabile.push('true')
            for (let nn = 0; nn < odds_instant[n].odds.length; nn++) {
              for (
                let nnn = 0;
                nnn < odds_instant[n].odds[nn].outcome.length;
                nnn++
              ) {
                if (
                  odds_instant[n].odds[nn].outcome[nnn]._attributes.id ==
                  id_outcome
                ) {
                  const odd_value_actual =
                    odds_instant[n].odds[nn].outcome[nnn]._attributes.odds
                  //se la quota attuale è più bassa
                  if (odd_value_actual < odd_value) {
                    moltiplicatore.push(odd_value_actual)
                  } else {
                    moltiplicatore.push(odd_value)
                  }
                }
              }
            }
          } else {
            applicabile.push('false')
            moltiplicatore.push(odd_value)
          }
        }
      }

      // only live events
      if (!applicabile.includes('false')) {
        const unique_val = moltiplicatore.filter(
          (v, i, a) => a.indexOf(v) === i
        )
        const old_molt = _.reduce(moltiplicatore_orig, _.multiply)
        const new_molt = _.reduce(unique_val, _.multiply)

        let diff_moltiplicatore = new_molt * amount_real
        diff_moltiplicatore = old_molt / diff_moltiplicatore - amount_real
        diff_moltiplicatore =
          diff_moltiplicatore * amount_real - amount_real - amount_real
        this.cashout = Math.abs(winning - Math.abs(diff_moltiplicatore))
      }

      this.loading = false
    },
    async checkCashoutPrematch(bet) {
      this.loading = true
      this.cashout_prematch = 0

      //cashout_percentage
      let rules_cashout_percentage = _.find(this.rules_skin, {
        detail: { context: 0 },
        type: 'percentage',
      })
      if (!rules_cashout_percentage) {
        rules_cashout_percentage = _.find(this.rules_manager, {
          detail: { context: 0 },
          type: 'percentage',
        })
      }

      if (rules_cashout_percentage) {
        var percentage_bookmaker = rules_cashout_percentage.detail.value
      } else {
        var percentage_bookmaker = 20
      }

      //cashout min_events
      let rules_cashout_min_events = _.find(this.rules_skin, {
        detail: { context: 0 },
        type: 'min_event',
      })
      if (!rules_cashout_min_events) {
        rules_cashout_min_events = _.find(this.rules_manager, {
          detail: { context: 0 },
          type: 'min_event',
        })
      }

      if (rules_cashout_min_events) {
        var min_events_cashout = rules_cashout_min_events.detail.value
      } else {
        var min_events_cashout = 2
      }

      //cashout min_odds
      let rules_cashout_min_odds = _.find(this.rules_skin, {
        detail: { context: 0 },
        type: 'min_odds',
      })
      if (!rules_cashout_min_odds) {
        rules_cashout_min_odds = _.find(this.rules_manager, {
          detail: { context: 0 },
          type: 'min_odds',
        })
      }

      if (rules_cashout_min_odds) {
        var min_odds_cashout = rules_cashout_min_odds.detail.value
      } else {
        var min_odds_cashout = 1.2
      }

      //cashout max_events
      let rules_cashout_max_events = _.find(this.rules_skin, {
        detail: { context: 0 },
        type: 'max_event',
      })
      if (!rules_cashout_max_events) {
        rules_cashout_max_events = _.find(this.rules_manager, {
          detail: { context: 0 },
          type: 'max_event',
        })
      }

      if (rules_cashout_max_events) {
        var max_events_cashout = rules_cashout_max_events.detail.value
      } else {
        var max_events_cashout = 7
      }

      const cashoutrisk = percentage_bookmaker
      const nr_events = bet.odds.length
      const perc_events = 100 / nr_events

      const perc_calc = (perc_events * cashoutrisk) / 100

      //valore principale di calcolo
      const value_percent_cashout =
        100 - (perc_events - (perc_events * cashoutrisk) / 100)
      const amount_real = bet.amount_real
      const winning = bet._multiple_detail.winning_total
      const bet_result = bet.result
      const bet_context = bet.bet_context
      const applicabile = []
      const moltiplicatore = []

      const in_checkout = []

      if (bet_context == 'prematch' && bet_result == 'pending') {
        const date_now = new Date()
        var evento_in_corso = false

        const count_events = bet.odds.length

        if (
          count_events >= min_events_cashout &&
          count_events <= max_events_cashout
        ) {
          for (let i = 0; i < count_events; i++) {
            const id_event = bet.odds[i].event_source
            const id_outcome = bet.odds[i].id_outcome
            const unique_id = bet.odds[i].unique_id
            const event_defined = bet.odds[i].defined ? true : false
            let odd_value = bet.odds[i].outcome_odd_value_for_order
            const type_event = bet.odds[i].type
            const event_void = bet.odds[i].void ? true : false
            const event_result = bet.odds[i].result ? bet.odds[i].result : 0
            const event_half_won = bet.odds[i].half_won
              ? bet.odds[i].half_won
              : 0
            const event_half_lose = bet.odds[i].half_lose
              ? bet.odds[i].half_lose
              : 0
            const event_time = bet.odds[i].time

            //se non rispetta la quota
            if (odd_value < min_odds_cashout) {
              return
            }

            if (
              event_defined == true &&
              (event_result == true || event_half_won)
            ) {
              if (event_half_won) {
                odd_value = odd_value / 2
              }
              in_checkout.push(odd_value)
            } else if (event_defined == false && event_time < date_now) {
              evento_in_corso = true
            }
          }
        }
      }

      //applicare cashout
      if (in_checkout.length > 0 && evento_in_corso == false) {
        let quota = 1
        for (let i = 0; i < in_checkout.length; i++) {
          quota *= in_checkout[i]
        }

        const vincita = amount_real * quota
        const profitto = vincita - amount_real
        const valore_cashout = (profitto * value_percent_cashout) / 100
        const importo_cashout = profitto - Math.abs(valore_cashout)
        const real_cashout = importo_cashout + amount_real

        this.cashout_prematch = real_cashout > 0 ? Math.abs(real_cashout) : 0
      }
      this.loading = false
    },
    async defineCashout() {
      const res_cashout = await this.sentCashout({
        code: this.betToShow.code,
        cashout:
          this.cashout > 0
            ? parseFloat(this.cashout).toFixed(2)
            : this.cashout_prematch > 0
            ? parseFloat(this.cashout_prematch).toFixed(2)
            : '',
      })
      await this.fetchMyBetsInProgress({ all: false })

      this.dialog = false
      this.dialog_cashout = false

      if (res_cashout.updated == true) {
        this.dialog_cashout_accept = true
      }

      if (res_cashout.updated == false) {
        this.dialog_cashout_reject = true
      }
    },
    async checkCashoutList(bets) {
      const contentbetinprogressnew = []
      if (!this.getCashoutLive && !this.getCashout) {
        return
      }

      var rules_cashout_percentage = _.find(this.rules_skin, {
        detail: { context: 1 },
        type: 'percentage',
      })
      if (!rules_cashout_percentage) {
        rules_cashout_percentage = _.find(this.rules_manager, {
          detail: { context: 1 },
          type: 'percentage',
        })
      }

      if (rules_cashout_percentage) {
        var percentage_bookmaker = rules_cashout_percentage.detail.value
      } else {
        var percentage_bookmaker = 0.97
      }

      for await (const bet of bets) {
        const amount_real = bet.amount_real
        var bet_result = bet.result
        const applicabile = []
        const moltiplicatore = []
        const defined = []
        const bet_type = bet.type

        const check_def = defined.includes(true)

        if (bet_type == 'single' || bet_type == 'multiple') {
          for (let i = 0; i < bet.odds.length; i++) {
            if (bet.odds[i].outcome_odd_value_for_order > 7) {
              this.visible_list_cashout.push(false)
              bet.check_cashout = false
              applicabile.push('false')
            }

            var id_event = bet.odds[i].event_source
            var id_outcome = bet.odds[i].id_outcome
            var odd_value = bet.odds[i].outcome_odd_value_for_order
            var unique_id = bet.odds[i].unique_id
            var type_event = bet.odds[i].type
            const ext_id = bet.odds[i].ext_id

            const odds_instant = await this.fetchCashout({
              id: id_event,
              outcome_id: id_outcome,
              unique_id: unique_id,
              ext_id: ext_id,
            })

            for (let n = 0; n < odds_instant.length; n++) {
              if (odds_instant[n].odds) {
                if (odds_instant[n].odds.outcome._attributes.id == id_outcome) {
                  const odd_value_actual = odds_instant[n].status.odds

                  /**
                   * Result (definizione quota, se zero equivale a non definita):
                   * -1  Cancelled  The bet settlement is cancelled
                   * 1  Loser      The bet has lost
                   * 2  Winner      The bet has won
                   * 3  Refund      There should be a refund
                   * 4  HalfLost  Half of the bet has lost
                   * 5  HalfWon      Half of the bet has won
                   *
                   * Status:
                   * 1  Open              The bet is open (bets can be placed)
                   * 2  Suspended          The bet is suspended (bets cannot be placed)
                   * 3  Settled              The bet is settled (resulted) – a settlement is determined (see settlement enumeration for additional information)
                   */
                  const status_odd = odds_instant[n].status.status
                  const definizione_result = odds_instant[n].status.result

                  const vincita = amount_real * odd_value
                  const probabilita = 1 / odd_value_actual
                  const vincita_nuova =
                    (vincita * probabilita * percentage_bookmaker) / amount_real

                  if (
                    type_event == 'live' &&
                    (status_odd == 1 || status_odd == 3) &&
                    bet_result == 'pending' &&
                    odd_value_actual <= 7
                  ) {
                    applicabile.push('true')
                    moltiplicatore.push(vincita_nuova)
                  } else {
                    applicabile.push('false')
                  }
                }
              }
            }
          }
        }

        var bet_result = bet.result
        const bet_context = bet.bet_context

        //cashout_percentage
        var rules_cashout_percentage = _.find(this.rules_skin, {
          detail: { context: 0 },
          type: 'percentage',
        })
        if (!rules_cashout_percentage) {
          rules_cashout_percentage = _.find(this.rules_manager, {
            detail: { context: 0 },
            type: 'percentage',
          })
        }

        if (rules_cashout_percentage) {
          var percentage_bookmaker = rules_cashout_percentage.detail.value
        } else {
          var percentage_bookmaker = 20
        }

        //cashout min_events
        let rules_cashout_min_events = _.find(this.rules_skin, {
          detail: { context: 0 },
          type: 'min_event',
        })
        if (!rules_cashout_min_events) {
          rules_cashout_min_events = _.find(this.rules_manager, {
            detail: { context: 0 },
            type: 'min_event',
          })
        }

        if (rules_cashout_min_events) {
          var min_events_cashout = rules_cashout_min_events.detail.value
        } else {
          var min_events_cashout = 2
        }

        //cashout min_odds
        let rules_cashout_min_odds = _.find(this.rules_skin, {
          detail: { context: 0 },
          type: 'min_odds',
        })
        if (!rules_cashout_min_odds) {
          rules_cashout_min_odds = _.find(this.rules_manager, {
            detail: { context: 0 },
            type: 'min_odds',
          })
        }

        if (rules_cashout_min_odds) {
          var min_odds_cashout = rules_cashout_min_odds.detail.value
        } else {
          var min_odds_cashout = 1.2
        }

        //cashout max_events
        let rules_cashout_max_events = _.find(this.rules_skin, {
          detail: { context: 0 },
          type: 'max_event',
        })
        if (!rules_cashout_max_events) {
          rules_cashout_max_events = _.find(this.rules_manager, {
            detail: { context: 0 },
            type: 'max_event',
          })
        }

        if (rules_cashout_max_events) {
          var max_events_cashout = rules_cashout_max_events.detail.value
        } else {
          var max_events_cashout = 7
        }

        const in_checkout = []

        if (bet_context == 'prematch' && bet_result == 'pending') {
          const date_now = new Date()
          let evento_in_corso = false
          const count_events = bet.odds.length

          if (
            count_events >= min_events_cashout &&
            count_events <= max_events_cashout
          ) {
            for (let i = 0; i < count_events; i++) {
              var id_event = bet.odds[i].event_source
              var id_outcome = bet.odds[i].id_outcome
              var unique_id = bet.odds[i].unique_id
              const event_defined = bet.odds[i].defined ? true : false
              var odd_value = bet.odds[i].outcome_odd_value_for_order
              var type_event = bet.odds[i].type
              const event_void = bet.odds[i].void ? true : false
              const event_result = bet.odds[i].result ? bet.odds[i].result : 0
              const event_half_won = bet.odds[i].half_won
                ? bet.odds[i].half_won
                : 0
              const event_half_lose = bet.odds[i].half_lose
                ? bet.odds[i].half_lose
                : 0
              const status_event = bet.odds[i].status_event
              const event_time = bet.odds[i].time

              //se non rispetta la quota
              if (odd_value < min_odds_cashout) {
                return
              }

              //se ce un evento in corso (che è diventato live)
              if (status_event == 2) {
                return
              }

              if (
                event_defined == true &&
                (event_result == true || event_half_won)
              ) {
                if (event_half_won) {
                  odd_value = odd_value / 2
                }

                in_checkout.push(odd_value)
              } else if (event_defined == false && event_time < date_now) {
                evento_in_corso = true
              }
            }
          }

          if (
            in_checkout.length > 0 &&
            evento_in_corso == false &&
            this.getCashout
          ) {
            this.visible_list_cashout.push(true)
            bet.check_cashout = true
          } else {
            this.visible_list_cashout.push(false)
            bet.check_cashout = false
          }

          if (bet_type == 'integral' || bet_type == 'system') {
            this.visible_list_cashout.push(false)
            bet.check_cashout = false
          }

          contentbetinprogressnew.push(bet)
        } else {
          if (bet_context == 'mixed') {
            applicabile.push('false')
          }

          if (!applicabile.includes('false')) {
            this.visible_list_cashout.push(true)
            bet.check_cashout = true
          } else {
            bet.check_cashout = false
            this.visible_list_cashout.push(false)
          }

          contentbetinprogressnew.push(bet)
        }
      }

      if (this.visible_list_cashout.includes(false)) {
        this.show_list_cashout = true
      }

      _.forEach(contentbetinprogressnew, el => {
        const check = _.find(this.betinprogressnew, { _id: el._id })
        if (!check) {
          this.betinprogressnew.push(el)
        }
      })
      const deletes = []
      _.forEach(this.betinprogressnew, el => {
        const check = _.find(contentbetinprogressnew, { _id: el._id })
        if (!check) {
          deletes.push(el)
        }
      })
      if (_.size(deletes) > 0) {
        _.forEach(deletes, del => {
          this.betinprogressnew = _.filter(this.betinprogressnew, function (o) {
            return o._id != del._id
          })
        })
      }
    },
    async checkCashoutListPrematch(bets) {
      this.skeleton_loader = true

      if (!this.getCashout) {
        return
      }

      for await (const bet of bets) {
        const bet_result = bet.result
        const bet_context = bet.bet_context

        const in_checkout = []

        if (bet_context == 'prematch' && bet_result == 'pending') {
          for (let i = 0; i < bet.odds.length; i++) {
            const id_event = bet.odds[i].event_source
            const id_outcome = bet.odds[i].id_outcome
            const unique_id = bet.odds[i].unique_id
            const event_defined = bet.odds[i].defined ? true : false
            let odd_value = bet.odds[i].outcome_odd_value_for_order
            const type_event = bet.odds[i].type
            const event_void = bet.odds[i].void ? true : false
            const event_result = bet.odds[i].result ? bet.odds[i].result : 0
            const event_half_won = bet.odds[i].half_won
              ? bet.odds[i].half_won
              : 0
            const event_half_lose = bet.odds[i].half_lose
              ? bet.odds[i].half_lose
              : 0

            if (
              event_defined == true &&
              (event_result == true || event_half_won)
            ) {
              if (event_half_won) {
                odd_value = odd_value / 2
              }
              in_checkout.push(odd_value)
            }
          }
        }
        //applicare cashout
        if (in_checkout.length > 0) {
          this.visible_list_cashout.push(true)
          bet.check_cashout = true
        } else {
          bet.check_cashout = false
          this.visible_list_cashout.push(false)
        }
        this.betinprogressnew.push(bet)
      }

      if (this.visible_list_cashout.includes(false)) {
        this.show_list_cashout = true
      }
      this.skeleton_loader = false
    },

    async checkCashoutListForeach(bet) {
      await this.checkCashoutList(bet)
    },
    async checkCashout2(bet) {
      if (bet.type == 'integral' || bet.type == 'system') {
        return
      }

      this.loading = true

      let rules_cashout_percentage = _.find(this.rules_skin, {
        detail: { context: 1 },
        type: 'percentage',
      })
      if (!rules_cashout_percentage) {
        rules_cashout_percentage = _.find(this.rules_manager, {
          detail: { context: 1 },
          type: 'percentage',
        })
      }

      if (rules_cashout_percentage) {
        var percentage_bookmaker = rules_cashout_percentage.detail.value
      } else {
        var percentage_bookmaker = 0.97
      }

      const amount_real = bet.amount_real
      const winning = bet._multiple_detail.winning_total
      const bet_result = bet.result

      const applicabile = []

      const moltiplicatore = []
      const defined = []

      const check_def = defined.includes(true)

      for (let i = 0; i < bet.odds.length; i++) {
        const id_event = bet.odds[i].event_source
        const id_outcome = bet.odds[i].id_outcome
        const odd_value = bet.odds[i].outcome_odd_value_for_order
        const unique_id = bet.odds[i].unique_id
        const type_event = bet.odds[i].type
        const ext_id = bet.odds[i].ext_id

        //odd_value check
        if (odd_value > 7) {
          return
        }

        const odds_instant = await this.fetchCashout({
          id: id_event,
          outcome_id: id_outcome,
          unique_id: unique_id,
          ext_id: ext_id,
        })
        for (let n = 0; n < odds_instant.length; n++) {
          if (odds_instant[n].odds) {
            if (odds_instant[n].odds.outcome._attributes.id == id_outcome) {
              if (odds_instant[n].livescore) {
                bet.odds[i].match_livescore = odds_instant[n].livescore
              }

              const odd_value_actual = odds_instant[n].status.odds

              /**
               * Result (definizione quota, se zero equivale a non definita):
               * -1	Cancelled	The bet settlement is cancelled
               * 1	Loser	    The bet has lost
               * 2	Winner	    The bet has won
               * 3	Refund	    There should be a refund
               * 4	HalfLost	Half of the bet has lost
               * 5	HalfWon	    Half of the bet has won
               *
               * Status:
               * 1	Open	            The bet is open (bets can be placed)
               * 2	Suspended	        The bet is suspended (bets cannot be placed)
               * 3	Settled	            The bet is settled (resulted) – a settlement is determined (see settlement enumeration for additional information)
               */
              const status_odd = odds_instant[n].status.status
              const definizione_result = odds_instant[n].status.result

              const vincita = amount_real * odd_value
              // var profitto = (vincita - amount_real);
              const probabilita = 1 / odd_value_actual
              const vincita_nuova =
                (vincita * probabilita * percentage_bookmaker) / amount_real

              if (
                type_event == 'live' &&
                (status_odd == 1 || status_odd == 3) &&
                bet_result == 'pending' &&
                odd_value_actual <= 7
              ) {
                applicabile.push('true')
                moltiplicatore.push(vincita_nuova)
              } else {
                applicabile.push('false')
              }
            }
          }
        }
      }

      var importo_cashout = 0

      // only live events
      if (!applicabile.includes('false')) {
        var importo_cashout = _.reduce(moltiplicatore, _.multiply)
        importo_cashout = importo_cashout * amount_real
        this.cashout = importo_cashout > 0 ? Math.abs(importo_cashout) : 0
      } else {
        this.cashout = 0
      }

      this.loading = false
    },
    sortby(array) {
      if (array.length > 0) {
        array = orderByLodash(array, ['source'], ['asc'])
        return array
      } else {
        return []
      }
    },
    result(type) {
      let response = type
      switch (type) {
        case 1:
          response = this.$t('statistics.corner')
          break
        case 6:
          response = this.$t('statistics.yellow')
          break
        case 7:
          response = this.$t('statistics.red')
          break
        case 8:
          response = this.$t('statistics.penalties')
          break
        case 9:
          response = this.$t('statistics.goal')
          break
        case 10:
          response = this.$t('statistics.substitutions')
          break
        case 24:
          response = this.$t('statistics.owngoal')
          break
        case 25:
          response = this.$t('statistics.penaltygoal')
          break
        case 40:
          response = this.$t('statistics.missedpenalty')
          break
        case 20:
          response = this.$t('statistics.aces')
          break
        case 21:
          response = this.$t('statistics.doublefaults')
          break
        case 34:
          response = this.$t('statistics.firstservewins')
          break
        case 12:
          response = this.$t('statistics.fouls')
          break
        case 28:
          response = this.$t('statistics.twopoints')
          break
        case 30:
          response = this.$t('statistics.threepoints')
          break
        case 31:
          response = this.$t('statistics.timeouts')
          break
        case 32:
          response = this.$t('statistics.freethrows')
          break
        case 33:
          response = this.$t('statistics.hits')
          break
      }
      return response
    },
    getSpecifiers(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        let seconds = time - minutes * 60
        seconds = parseFloat(bet.seconds).toFixed(2)
        if (seconds > 0) {
          if (seconds < 10) {
            return minutes + ':0' + seconds
          } else {
            return minutes + ':' + seconds
          }
        } else {
          return minutes
        }
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    async rebet(odds) {
      const now = new Date()
      this.dialog = false
      await this.resetCart()
      await this.setOddsInCart(odds)
      await this.setCreatedAtCart(now.getTime())
      await this.refreshCart()
      await this.$root.$emit('sectionCart')
    },
    async getLiveDate(eventSource) {
      const data = await this.fetchEventResultAndTimeDetail({
        source: eventSource,
      })

      return data
    },
    async allMyBets() {
      this.overlay = true
      await this.searchBets()
      this.dialog_betlist = true
      this.overlay = false
    },
    async searchBets() {
      this.overlay_dialog_betlist = true
      const fromTime = this.getEpochTimes().fromTime
      const toTime = this.getEpochTimes().toTime

      const criteria = {
        ...(this.filterType !== '' && { type: this.filterType }),
        ...(this.filterResult !== '' && { result: this.filterResult }),
        ...(this.filterPayed !== '' && { payed: this.filterPayed }),
        ...(this.filterCode !== '' && { code: this.filterCode }),
        ...(this.filterContext !== '' && { bet_context: this.filterContext }),
        ...(this.filterFromTime !== '' && { fromTime: fromTime }),
        ...(this.filterToTime !== '' && { toTime: toTime }),
        ...(this.cashout_filter !== '' && { cashout: this.cashout_filter }),
      }

      const cashout = true
      await this.fetchMyBetsInProgressAllFilter(criteria)
      this.overlay_dialog_betlist = false
    },
    async resetFilter() {
      this.filterType = ''
      this.filterResult = ''
      this.filterPayed = ''
      this.filterCode = ''
      this.filterContext = ''
      this.filterFromTime = ''
      this.filterToTime = ''
      await this.searchBets()
    },
    handleClick(value) {
      this.openDetail(value)
    },
    async handleKeyDown(e) {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        await this.searchBets()
      }
    },
    getEpochTimes() {
      const DEFAULT_TIMEZONE = 'Europe/Malta'
      const platformSettings = this.getPlatformSettings
      let timezone = platformSettings.timezone
      timezone = timezone != null ? timezone : DEFAULT_TIMEZONE

      const fromTime =
        this.filterFromTime && this.filterFromTime.trim() !== ''
          ? this.filterFromTime
          : moment.tz(timezone).startOf('day').format('YYYY-MM-DD')

      const toTime =
        this.filterToTime && this.filterToTime.trim() !== ''
          ? this.filterToTime
          : moment.tz(timezone).endOf('day').format('YYYY-MM-DD')

      // Converte in epoch con il timezone specificato
      const fromTimeEpoch = moment
        .tz(fromTime, timezone)
        .startOf('day')
        .valueOf()
      const toTimeEpoch = moment.tz(toTime, timezone).endOf('day').valueOf()

      return {
        fromTime: fromTimeEpoch,
        toTime: toTimeEpoch,
      }
    },
  },
  async created() {
    await this.fetchMyBetsInProgress({ all: false })
    this.rules_manager = _.filter(this.getRulesManager, { scope: 'cashout' })
    this.rules_skin = _.filter(this.getRulesSkin, { scope: 'cashout' })
  },
}
</script>

<style>
.text-count-mybets {
  font-size: 12px;
  font-weight: bold;
}

.v-dialog.v-dialog--datepicker.v-dialog--active {
  width: auto;
}

.datatable-mybets tr {
  cursor: pointer;
}

.v-dialog.modal-mybetlist.v-dialog--active {
  width: 100% !important;
}
.fs12 {
  font-size: 12px !important;
}
</style>
